// extracted by mini-css-extract-plugin
export default {"totalVolumeBox":"volume_totalVolumeBox__jKwHQ","secondaryText":"volume_secondaryText__fqPxz","coloredBox":"volume_coloredBox__U0tWl"};